import {
  action$,
  dispatchAction,
  extractPayload,
  ofType,
} from '@ardoq/rxbeach';
import { tap, withLatestFrom } from 'rxjs';
import { selectMetamodelItem, setMetamodelContext } from './actions';
import { getContextFromMetamodelItem } from './utils';
import { metamodel$ } from '../metamodel$';

export const handleSelectMetamodelItem = action$.pipe(
  ofType(selectMetamodelItem),
  extractPayload(),
  withLatestFrom(metamodel$),
  tap(([selectedItem, metamodel]) => {
    const context = metamodel
      ? getContextFromMetamodelItem(metamodel, selectedItem)
      : null;
    if (context) {
      dispatchAction(setMetamodelContext(context));
    }
  })
);
